import { LogLevel, Configuration, RedirectRequest } from '@azure/msal-browser';

/**
 * UAT Environment Configuration
 * Azure AD B2C Authentication (for external candidates)
 * Azure AD Corporate Authentication (for Microsoft employees)
 */

// Azure AD B2C Configuration - for external candidates
const b2cTenantName = 'hroffboarding'; // e.g., 'contosob2c'
const b2cTenantId = '332a0960-e037-4f11-bf0f-6a64a4c9b727'; // Your B2C tenant domain
const b2cPolicyName = 'B2C_1_onboardingUAT'; // Your sign-up/sign-in policy name

// Azure AD Corporate Configuration - for Microsoft employees
const aadTenantId = '72f988bf-86f1-41af-91ab-2d7cd011db47'; // Microsoft corporate tenant

export const msalConfig: Configuration = {
  auth: {
    clientId: '6f4223f0-2989-4df6-940d-f53bc330330f', // Replace with your B2C app client ID
    authority: `https://loginnewhirehub.microsoft.com/${b2cTenantId}/${b2cPolicyName}`,
    knownAuthorities: [`${b2cTenantName}.b2clogin.com`, 'loginnewhirehub.microsoft.com'],
    redirectUri: 'https://onboarding-client-uat-ene8fvgafea4ffbg.b01.azurefd.net/auth/b2c',
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// Azure AD Corporate MSAL Configuration for Microsoft employees
export const msalConfigCorporate: Configuration = {
  auth: {
    clientId: '5a25faaf-115f-48b3-8640-32c03c9804d6', // TODO: Replace with your Azure AD app client ID if different
    authority: `https://login.microsoftonline.com/${aadTenantId}`,
    redirectUri: 'https://onboarding-client-uat-ene8fvgafea4ffbg.b01.azurefd.net/auth/corporate',
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// B2C scopes for external candidates
const b2cScopes = ['https://hroffboarding.onmicrosoft.com/6f4223f0-2989-4df6-940d-f53bc330330f/user-impersonation'];

// Corporate scopes for Microsoft employees
const corporateScopes = [
  'api://5a25faaf-115f-48b3-8640-32c03c9804d6/user-impersonation',
  'api://5a25faaf-115f-48b3-8640-32c03c9804d6/default',
];

export const getLoginRequest = (authProvider: 'b2c' | 'corporate'): RedirectRequest => {
  const scopes = authProvider === 'corporate' ? corporateScopes : b2cScopes;
  return { scopes };
};

export const loginRequest: RedirectRequest = {
  scopes: b2cScopes,
};

export const loginRequestCorporate: RedirectRequest = {
  scopes: corporateScopes,
};

// UAT-specific settings
export const apiConfig = {
  baseUrl: 'https://onboarding-client-uat-ene8fvgafea4ffbg.b01.azurefd.net',
  timeout: 15000,
};

export const appConfig = {
  enableDebugMode: true,
  enableAnalytics: true,
  logLevel: LogLevel.Info,
  applicationInsightsConnectionString:
    'InstrumentationKey=42f0eb51-dba7-4e1d-aefa-7ec2b3fd810d;IngestionEndpoint=https://westus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://westus.livediagnostics.monitor.azure.com/;ApplicationId=6cd2df0d-897f-4017-be89-6f73f92dc8ad',
};
